import React  from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { FilePickerCaseList } from "./file-picker-case-list";
import { useQuery } from "@apollo/client";
import { StaffFilePickerCaseListContainerCredentialVerificationCaseV1Document } from "../../../../../../generated";
import { useParams } from "react-router-dom";

interface FilePickerCaseListContainerProps {
    setCaseInfo: (selectedCaseId: string, selectedCaseType: string, isArchived?: boolean) => void;
}

export const FilePickerCaseListContainer: React.FC<
FilePickerCaseListContainerProps
> = (props) => {
    const params = useParams();
    const caseId = params.caseId || "";

    const {
        data: applicantIdData,
        loading: applicantIdLoading,
        error: applicantIdError,
      } = useQuery(
        StaffFilePickerCaseListContainerCredentialVerificationCaseV1Document,
        {
          variables: {
            credentialVerificationCaseV1Id: caseId,
          },
        }
      );
    
      const applicantId =
        applicantIdData?.credentialVerificationCaseV1?.applicant?.id;
      const applicantName =
        applicantIdData?.credentialVerificationCaseV1?.applicant?.displayName ?? "";
  

  return (
    <ComponentQueryLoader
      loading={applicantIdLoading}
      error={applicantIdError}
      hasData={applicantId}
      hasDataComponent={<FilePickerCaseList setCaseInfo={props.setCaseInfo} applicantName={applicantName} applicantId={applicantId} />}
    />
  );
};
